var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TitleWithBackButton',{attrs:{"title":"","back-route":"Settings","icon":"mdi-graphql"}}),_c('CompanyHoursData',{staticClass:"pa-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }